<div class="modal-header">
  <h4 class="custom-title">Submit Recommendation</h4>
  <button mat-icon-button type="button" aria-label="Close" (click)="recommendationModal.dismiss(null)">
    <i class="fas fa-times"></i>
  </button>
</div>
<div style="width: 98%;padding-left: 2%;padding-bottom: 1%;">
  <div class="row" *blockUI="'save-user-recommendation'">
    <div class="modal-body">
      <div class="row">
        <form #recommendationForm="ngForm" autocomplete="off">
          <div class="col-sm-12">
            <mat-form-field style="width: 100%;">
              <textarea matInput maxlength="1200" placeholder="Your Recommendation" name="inputTxt"
                [(ngModel)]="inputTxt" cdkTextareaAutosize cdkAutosizeMinRows="6" required></textarea>
            </mat-form-field>
          </div>
        </form>
      </div>
    </div>
    <div class="modal-footer" style="border-top: none;">
      <button type="button" class="btn btn-secondary"
        (click)="recommendationModal.dismiss('cancel')">Cancel</button>&nbsp;&nbsp;
      <button type="button" class="btn btn-primary" (click)="saveRecommendation()"
        [disabled]="recommendationForm.invalid">Submit</button>
    </div>
  </div>
</div>